module.exports = __webpack_public_path__ + "img/winner-certificate.10fe82bd.svg";